/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
// Import PolymerElement class
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import { mixinBehaviors } from "@polymer/polymer/lib/legacy/class.js"; // define the element's class element

class profileContactDetailsPhoneTab extends mixinBehaviors([accessibilityBehaviours.commonFunctions, sbBehaviours.currencyFormatorBehaviour, corpBehaviours.appCommonBehaviour], PolymerElement) {
  static get template() {
    return html`
         
          <style  include="app-styles">  
            div[preferredBackground]{
              background: var(--brand-color);
            } 
            div[preferredLabel]{
              color: var(--primary-light-color);
            } 
            div[preferredContactNumber]{
              color: var(--secondary-light-color);
            } 
            paper-icon-button[preferredIcon]{
              color: var(--primary-light-color);
            }
            div[preferredAddIcon]{
              color: var(--primary-light-color) !important;
            }
            .ironListNoXScroll{
              overflow-x:hidden;
              overflow-y:hidden !important;
            }
            .paddingTop4{
              padding-top:4%;
            }
            .EditButtonWidth{
            width: calc(25% - 8px) !important;
            }
         </style>
         <!-- ajax call for codeType = PFPH -->
         <oe-ajax id="phoneFetch" url="/api/CBUsers/{{userId}}/personaldetails" on-response="updatedPhoneDetailsResponse" on-error="adressListError"></oe-ajax>

        <oe-ajax id="phoneTypeFetch" url="/api/codereferences?filter[where][codeType]=PFPH" auto on-response="communicationTypeResponse" on-error="adressListErrorNew"></oe-ajax>
         
          <div class="mdl-grid"></div>
          <template is="dom-if" if="{{phoneTypes.length}}" restamp='true'>
            <iron-list class="listing-1 ironListNoXScroll" items="{{phoneTypes}}" role="list" id="phone-ironlist">
              <template>
              <div class="mdl-grid mdl-cell--12-col padding-t-zero padding-b-zero" >
                <div role="listitem" aria-selected="undefined" aria-readonly="true" preferredBackground$="{{item.preferredContact}}" id="phone_background_{{index}}" class="mdl-cell border-1px border-round-8px mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col margin-b-zero padding-zero">
                  <div class="mdl-grid padding-r-zero">
                    <div class="outlineOffset margin-b-zero margin-l-zero margin-t-zero mdl-cell mdl-cell--3-col-phone mdl-cell--6-col-tablet mdl-cell--9-col" id="focused-div" tabindex=0>
                      <div preferredLabel$="{{item.preferredContact}}" id="phone_label_{{index}}" class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col font-size-m">
                        <oe-i18n-msg msgid="{{item.editLabel}}"></oe-i18n-msg>
                      </div>
                      <div preferredContactNumber$="{{item.preferredContact}}" id="phone_number_{{index}}" class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col secondary-dark-text-s">
                        <template is="dom-if" if="{{item.isContactPresent}}">
                          {{item.contactNumber}}
                        </template>
                        <template is="dom-if" if="{{!item.isContactPresent}}">
                          <oe-i18n-msg msgid="{{item.label}}"></oe-i18n-msg>
                        </template>
                      </div>
                    </div> 
                    <template is="dom-if" if="{{item.isContactPresent}}">
                      <div class="EditButtonWidth margin-r-zero margin-t-zero mdl-cell mdl-cell--1-col-phone mdl-cell--2-col-tablet mdl-cell--3-col secondary-dark-text-s text-align-right">
                        <paper-icon-button class="iron-icon-style-m" preferredIcon$="{{item.preferredContact}}" id="phone_edit_icon_{{index}}" icon="pencil" on-keydown="setFocus" on-tap="modifyPhone" aria-label$="{{item.editAriaLabel}}"></paper-icon-button>
                      </div>
                    </template>
                    <template is="dom-if" if="{{!item.isContactPresent}}">
                      <div class="paddingTop4 mdl-cell mdl-cell--1-col-phone mdl-cell--2-col-tablet mdl-cell--3-col secondary-dark-text-s text-align-right">
                        <div preferredAddIcon$="{{item.preferredContact}}" id="phone_add_button" on-keydown="setFocus" on-tap="modifyPhone" class="outlineOffset cursor-pointer text-brand-color flat-button" tabindex="0">
                        <oe-i18n-msg tabindex="0" msgid="b_AddWithPlusSign" role="button" aria-label$="{{item.addAriaLabel}}" class="outlineOffset"></oe-i18n-msg>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              </template>
            </iron-list>
            </template>
            
          `;
  }

  static get properties() {
    return {
      //To store all the phone types
      phoneTypes: {
        type: Array,
        notify: true,
        value: []
      },
      //Iron page selector for pages in profile-main
      myprofilepagenumber: {
        type: Number,
        notify: true
      },
      //Iron page selectore for pages in contact details tabs
      selectedPhoneDetails: {
        type: Object,
        notify: true
      },
      //To store all the address and contact details
      commDetails: {
        type: Array,
        notify: true
      },
      personalDetails: {
        type: Array,
        notify: true,
        observer: "addressResponse"
      },
      fromPhoneEditPage: {
        type: Boolean,
        notify: true,
        observer: "checkBooleanValue"
      },
      personalDetailsResponse: {
        type: Array,
        notify: true
      }

    };
  }

  connectedCallback() {
    super.connectedCallback();
    //this.$$("#addressFetch").generateRequest();
  } //called when communication details are recieved


  addressResponse() {
    this.commDetails = [];
    this.commDetails.push(this.personalDetails);
    if (this.commDetails != undefined && this.commDetails[0].contactDetails != undefined)
      this.getPhoneTypes();
    this.fire('stop-processing-loader');
  }  //This functions creates the list of phone types with the details


  getPhoneTypes() {
    var self = this;
    var contactDetails = [];
    var preferredEmail = "";
    if (self.commDetails && self.commDetails[0].contactDetails && self.commDetails[0].contactDetails.length > 0) {
    for (let i = 0; i < self.commDetails[0].contactDetails.length; i++) {
      if (self.commDetails[0].contactDetails[i].contactType.codeType == "PFPH") {
        contactDetails.push(self.commDetails[0].contactDetails[i]);
      }
      if (self.commDetails[0].contactDetails[i].contactType.codeType == "PFML") {
        preferredEmail = self.commDetails[0].contactDetails[i].contactType.cmCode;
      }
    }
   }
      if (self.phoneTypes && self.phoneTypes.length > 0) {
    for (let i = 0; i < self.phoneTypes.length; i++) {
      self.phoneTypes[i].preferredEmail = preferredEmail;
      self.phoneTypes[i].isContactPresent = false;
      self.phoneTypes[i].preferredContact = false;
      for (let j = 0; j < contactDetails.length; j++) {
        if (self.phoneTypes[i].cmCode == contactDetails[j].contactType.cmCode) {
          if (contactDetails[j].preferredContact.cmCode == "Y") {
            self.phoneTypes[i].alwaysPreferred = true;
            self.phoneTypes[i].preferredContact = true;
            self.phoneTypes[i].preferredcmCode = contactDetails[j].contactType.cmCode;
          }
          else{
            self.phoneTypes[i].alwaysPreferred = false;
            self.phoneTypes[i].preferredContact = false;
            self.phoneTypes[i].preferredcmCode = "";

          }
          if (contactDetails[j].contactNumber != 0) {
            self.phoneTypes[i].originalPhone = String(contactDetails[j].contactNumber);
            self.phoneTypes[i].contactNumber = String(contactDetails[j].contactNumber);
            self.phoneTypes[i].contactNumberCountryCode = String(contactDetails[j].contactNumberCountryCode);
            self.phoneTypes[i].isContactPresent = true;
            self.phoneTypes[i].updateScenario = true
          }

          if (self.phoneTypes[i].cmCode == "FAX1") self.phoneTypes[i].pageTitle = "h_updateFaxNumber"; else if (self.phoneTypes[i].cmCode == "CELLPH") self.phoneTypes[i].pageTitle = "h_updateMobileNumber"; else if (self.phoneTypes[i].cmCode == "HOMEPH1") self.phoneTypes[i].pageTitle = "h_updateHomeNumber"; else if (self.phoneTypes[i].cmCode == "WORKPH1") self.phoneTypes[i].pageTitle = "h_updateWorkNumber"; else if (self.phoneTypes[i].cmCode == "COMMPH1") self.phoneTypes[i].pageTitle = "h_updateCommunicationNumber";
        }
      }
    }
    //Update the phone type number after successfully updation
                    let phoneTypes = _.cloneDeep(this.phoneTypes);
                    this.set('phoneTypes', []);
                    this.set('phoneTypes', phoneTypes);
                    if (this.$$('#phone-ironlist')) {
                        this.$$('#phone-ironlist')._render();
                    }
                }
  } //This function navigates to the input page of the selected phone number


  modifyPhone(event) {
    var data = event.model.item;
    this.selectedPhoneDetails = _.cloneDeep(data);
    this.myprofilepagenumber = 10;
  }

  setFocus(event) {
    for (let i = 0; i < this.phoneTypes.length; i++) {
      if (event.model.__data.index == this.phoneTypes.length - 1) {
        if (!event.shiftKey && (event.keyCode === 9 || KeyboardEvent.charCode == 9 || KeyboardEvent.keyCode == 9 || event.which == 9)) {
          this.shadowRoot.querySelector("#focused-div").focus();
        }
      }
    }
  }
   //According to Phone types based on cmCode responses displaying on UI
        communicationTypeResponse(e) {
            let phoneTypesList = e.detail.response;
            this.set('phoneTypes', []);
            for (let i = 0; i < phoneTypesList.length; i++) {
                let tempPhoneTypes = {};
                if (phoneTypesList[i].cmCode == 'FAX1') {
                    tempPhoneTypes.cmCode = phoneTypesList[i].cmCode,
                        tempPhoneTypes.codeDescription = phoneTypesList[i].codeDescription,
                        tempPhoneTypes.label = 'l_faxNumberNotFound',
                        tempPhoneTypes.editLabel = 'l_faxnumber',
                        tempPhoneTypes.pageTitle = 'h_addFaxNumber',
                        tempPhoneTypes.cType = 'faxNumber',
                        tempPhoneTypes.addAriaLabel = getLabel('m_AddFaxNumber'),
                        tempPhoneTypes.editAriaLabel = getLabel('m_EditFaxNumber')
                }
                if (phoneTypesList[i].cmCode == 'CELLPH') {
                    tempPhoneTypes.cmCode = phoneTypesList[i].cmCode,
                        tempPhoneTypes.codeDescription = phoneTypesList[i].codeDescription,
                        tempPhoneTypes.label = 'l_mobileNumberNotFound',
                        tempPhoneTypes.editLabel = 'l_Mnmber',
                        tempPhoneTypes.pageTitle = 'h_addMobileNumber',
                        tempPhoneTypes.cType = 'mobileNumber',
                        tempPhoneTypes.addAriaLabel = getLabel('m_AddMobileNumber'),
                        tempPhoneTypes.editAriaLabel = getLabel('m_EditMobileNumber')
                }
                if (phoneTypesList[i].cmCode == 'COMMPH1') {
                    tempPhoneTypes.cmCode = phoneTypesList[i].cmCode,
                        tempPhoneTypes.codeDescription = phoneTypesList[i].codeDescription,
                        tempPhoneTypes.label = 'l_communicationNumberNotFound',
                        tempPhoneTypes.editLabel = 'l_communicationNumber',
                        tempPhoneTypes.pageTitle = 'h_addCommunicationNumber',
                        tempPhoneTypes.cType = 'communicationContactNumber',
                        tempPhoneTypes.addAriaLabel = getLabel('m_AddMobileNumber'),
                        tempPhoneTypes.editAriaLabel = getLabel('m_EditMobileNumber')
                }
                if (phoneTypesList[i].cmCode == 'HOMEPH1') {
                    tempPhoneTypes.cmCode = phoneTypesList[i].cmCode,
                        tempPhoneTypes.codeDescription = phoneTypesList[i].codeDescription,
                        tempPhoneTypes.label = 'l_homeNumberNotFound',
                        tempPhoneTypes.editLabel = 'l_homeNumber',
                        tempPhoneTypes.pageTitle = 'h_addHomeNumber',
                        tempPhoneTypes.cType = 'homeContactNumber',
                        tempPhoneTypes.addAriaLabel = getLabel('m_AddHomeNumber'),
                        tempPhoneTypes.editAriaLabel = getLabel('m_EditHomeNumber')
                }
                if (phoneTypesList[i].cmCode == 'WORKPH1') {
                    tempPhoneTypes.cmCode = phoneTypesList[i].cmCode,
                        tempPhoneTypes.codeDescription = phoneTypesList[i].codeDescription,
                        tempPhoneTypes.label = 'l_workNumberNotFound',
                        tempPhoneTypes.editLabel = 'l_workNumber',
                        tempPhoneTypes.pageTitle = 'h_addWorkNumber',
                        tempPhoneTypes.cType = 'workContactNumber',
                        tempPhoneTypes.addAriaLabel = getLabel('m_AddWorkNumber'),
                        tempPhoneTypes.editAriaLabel = getLabel('m_EditWorkNumber')
                }
                tempPhoneTypes.codeType = phoneTypesList[i].codeType,
                    tempPhoneTypes.originalPhone = "",
                    tempPhoneTypes.contactNumber = "",
                    tempPhoneTypes.tempFlag = true,
                    tempPhoneTypes.updateScenario = false

                this.push('phoneTypes', tempPhoneTypes);
            }
            this.getPhoneTypes();
        }

checkBooleanValue() {
    if (this.fromPhoneEditPage) {
      this.$$("#phoneFetch").generateRequest();
      this.fromPhoneEditPage = false;
    }
  }

  updatedPhoneDetailsResponse(e) {
    var response = e.detail.response;
    this.personalDetails = response;
    this.personalDetailsResponse = response;
    this._refreshPhoneDetails();
  }
  _refreshPhoneDetails() {
    var temp = _.cloneDeep(this.phoneTypes);
    this.phoneTypes = [];
    this.phoneTypes = temp;
    var ironList = this.$$("#phone-ironlist");
    ironList.__data.items = this.phoneTypes;
    if (ironList) {
      ironList._render();
    }

  }



} // Associate the new class with an element name


customElements.define('profile-contact-details-phone-tab', profileContactDetailsPhoneTab);